import React from 'react'

/**
 * Context to be provided to all number picker components that are interested in
 * starting the process of reserving a number and/or listening on the status of whether a number
 * is being reserved.
 */
export const ReserveNumberContext = React.createContext({})
